import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {Tooltip} from "@mui/material";

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 * @param String title
 * @param String value
 * @param String className
 * @returns {JSX.Element}
 */
const RowResumeText = ({ title, value = [], className, tooltip='' }) => {
    const { t } = useTranslation();
    const elementRef = useRef(null);
    const [isTruncated, setIsTruncated] = useState(false);

    useEffect(() => {
        if (elementRef.current) {
            const spanElement = elementRef.current;
            if (spanElement) {
                setIsTruncated(spanElement.scrollWidth > spanElement.clientWidth);
            }
        }
    }, [value]);

    return (
        <div className={'row-resume ' + className}>
            <h6 className=' mb-1 ibl-font-w-600 fs-14px'>{t(title)}</h6>
            {Array.isArray(value) ? (
                <ul className='mb-0 ibl-font-w-300 ibl-label list-unstyled'>
                    {value.map((item, idx) => (
                        <li key={idx} className='text-body'>
                            {item}
                        </li>
                    ))}
                </ul>
            ) : isTruncated && tooltip ? (
                <Tooltip title={tooltip} placement='top'>
                    <span ref={elementRef} className='resume-text mb-0 fs-14px d-inline-block text-truncate'>
                        {value}
                    </span>
                </Tooltip>
            ) : (
                <span
                    ref={elementRef}
                    className={'resume-text mb-0 fs-14px d-inline-block text-wrap' + (tooltip ? ' text-truncate' : '')}
                >
                    {value || '-'}
                </span>
            )}
        </div>
    );
};

export default RowResumeText;
